// @ts-check
import { h } from "common/dom-builder";

export class AlignmentSelector {
  /** @type {import("../types").ToolBuildMethod<AlignmentSelector>} */
  static buildElementForHeader(typeTester) {
    if (!typeTester.isFormattable) return;

    const element = h(
      "div",
      {
        class: [
          "input-group",
          "alignment-input-group",
          "button-group",
          "tool-panel",
        ],
        "data-input-group": "alignment",
      },
      [
        h("div", { class: "icon-button align-left-button" }),
        h("div", { class: "icon-button align-center-button" }),
      ]
    );
    const instance = new AlignmentSelector({ element, typeTester });
    return { element, instance };
  }

  constructor(props) {
    this.element = props.element;
    this.props = props;
    this.init();
  }

  init() {
    ["left", "center"].forEach((alignment) => {
      this.element
        .querySelector(`.align-${alignment}-button`)
        .addEventListener("click", () => {
          console.log("align: ", alignment);
          this.props.typeTester.textEditor.setAlignment(alignment);
          this.props.typeTester.element.dispatchEvent(
            new CustomEvent("interaction")
          );
        });
    });
  }
}
